import { TipoNotificacaoEnum } from "../enums/tipo-notificacao-enum";
import { TipoStatusNotificacaoEnum } from "../enums/tipo-status-notificacao-enum";
import { Util } from "../util/util";

export class LoteNotificacaoSmsDTO {

    numLote: number | null = null;

    tipoNotificacao: TipoNotificacaoEnum | null = null;

    dataNotificacao: Date | null = null;

    codStatusNotificacaoSms: string | null = null;

    dscStatusNotificacaoSms: string | null = null;

    dscMotivoNotificacao: string | null = null;

    dscMensagemNotificacao: string | null = null;

    tipoStatusNotificacao: TipoStatusNotificacaoEnum | null = null;

    dataInicialLoteNotificacao: Date | null = null;

    dataFinalLoteNotificacao: Date | null = null;

    constructor() {
    }

    temFiltroPreenchido(): boolean {

        return this.dataInicialLoteNotificacao !== null ||
            this.dataFinalLoteNotificacao !== null ||
            this.numLote !== null ||
            this.dscMotivoNotificacao !== null;
    }

    getIconeTipoStatusNotificacao(): string {

        return Util.getIconeTipoStatusNotificacao(this.tipoStatusNotificacao);
    }

    getCorTipoStatusNotificacao(): string {

        return Util.getCorTipoStatusNotificacao(this.tipoStatusNotificacao);
    }

    getTooltipTipoStatusNotificacao(): string {

        return Util.getTooltipTipoStatusNotificacao(this.tipoStatusNotificacao);
    }
}

